import React, {useState, useEffect} from 'react';
import Card from '../Card/Card';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import CardSeeMore from '../Card/CardSeeMore';
import TitleSection from '../../atoms/TitleSection';
import SeeMore from '../../atoms/SeeMore';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import {gtmProductImpressions} from '../../services/gtmEvents';

const TitleLoading = styled.div`
  height: 50px;
  margin-bottom: 10px;
  width: 380px;

  @media (max-width: 991px) {
    display: flex;
    justify-content: center;
    width: 100%;
  }
`;

const Carousel = ({title, listingUrl, products, cardType, isFestival, showLoading = true, backColor, fontColor, homeMounted, width}) => {
  const { t } = useTranslation();
  const xs = 425;
  const sm = 576;
  const md = 768;
  const lg = 992;
  const xl = 1200;
  const resizedWindow = width >= lg ? 'lg' : width >= md ? 'md' : width >= sm ? 'sm' : width >= xs ? 'xs' : 'xxs';
  const [dataLayerPushedProducts, setDataLayerPushedProducts] = useState([]);

  const manageGTMImpression = (items, startIndex) => {
    gtmProductImpressions(items, startIndex, title);
  };

const manageAfterChange = (e) => {
  if(width && width >= lg){
    manageGTMImpression(products.slice(e, e+4), e);
  }else if(width && width >= md){
    manageGTMImpression(products.slice(e, e+3), e);
  }else if(width && width >= xs){
    manageGTMImpression(products.slice(e, e+2), e);
  }else if(width && width > 0){
    manageGTMImpression(products.slice(e, e+1), e);
  }
};

useEffect(() => {
  if (width && width < lg && !isFestival) {
    if(dataLayerPushedProducts.length < products.length && homeMounted)
      if(width >= sm && cardType == 'mini'){
        manageGTMImpression(products && products.slice(0, 8), 0);
      }else{
        manageGTMImpression(products && products.slice(0, 6), 0);
      }
  }else{
    if(width && width >= lg){
      if(dataLayerPushedProducts.length < 4 && homeMounted)
        manageGTMImpression(products && products.slice(0, 4), 0);
    }else if(width && width >= md){
      if(dataLayerPushedProducts.length < 3 && homeMounted)
        manageGTMImpression(products && products.slice(0, 3), 0);
    }else if(width && width >= xs){
      if(dataLayerPushedProducts.length < 2 && homeMounted)
        manageGTMImpression(products && products.slice(0, 2), 0);
    }else if(width && width > 0){
      if(dataLayerPushedProducts.length < 1 && homeMounted)
        manageGTMImpression(products && products.slice(0, 1), 0);
    }
  }
},[products, homeMounted, resizedWindow]);

  let festivalName = '';
  let cardTypeClass = 'card';
  if (isFestival) {
    festivalName = title;
  } else {
    if (cardType !== undefined && cardType.trim() !== '' && width < lg) {
      cardTypeClass += ' card-' + cardType;
    }
  }

  let cards;
  if (showLoading){
    if(!cardType || width > lg) {
      cards = Array(4).fill(4).map((n, index) => {
        return <div key={index}><div className={'card'}><div className={'animated-background'}/></div></div>;
      })
    } else {
      if(cardType === 'horizontal') {
        cards = Array(6).fill(6).map((n, index) => {
          return <div style={{display : 'flex', width: width < sm ? '100%' : '50%'}} key={index}><div className={'card animated-mini-horizontal'}><div className={'animated-background'}/></div></div>;
        })
      } else {
        const cantCards = width < sm ? 6 : 8;
        cards = Array(cantCards).fill(cantCards).map((n, index) => {
          return <div style={{display : 'flex', width: width < sm ? '49%' : '22%'}} key={index}><div className={'card animated-mini-horizontal'}><div className={'animated-background'}/></div></div>;
        })
      }
    }
  } else {
    cards = products && products.map((p, index) => {
      return (
        <Card
          key={index}
          product={p}
          label={festivalName}
          cardType={cardTypeClass}
          backColor={backColor}
          fontColor={fontColor}
          title={title}
          position={index}
          width={width}/>
          )
        ;
    });
  }

  let showArrows = width >= lg;
  const settings = {
    arrows: showArrows,
    infinite: false,
    speed: 500,
    swipeToSlide: true,
    easing: 'linear',
    slidesToShow: 4,
    afterChange: manageAfterChange,
    variableWidth: true,
    responsive: [
      {
        breakpoint: xl,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: lg,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: md,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  let contentSlide;
  if (width < lg && !isFestival) {
    if(width < sm){
      contentSlide = <div className={'card-flex-container'}>
      {cards.slice(0,6)}
    </div>;
    }else{
      contentSlide = <div className={'card-flex-container'}>
      {cards.slice(0,cardType == 'mini'? 8 : 6)}
    </div>;
    }
  } else {
    contentSlide = <Slider {...settings}>
      {cards}
      <CardSeeMore description={title} url={listingUrl} cardType={cardTypeClass}/>
    </Slider>;
  }

  let titleSlide;
  if (showLoading){
    titleSlide = <TitleLoading className="container"><div className="animated-background animated-title"/></TitleLoading>
  } else {
    titleSlide = <TitleSection title={title} url={listingUrl} vermas={t('see_more')}/>
  }

  let seeMoreSlide;
  if (showLoading){
    seeMoreSlide = <TitleLoading><div className="animated-background"/></TitleLoading>
  } else {
    seeMoreSlide = <SeeMore url={listingUrl} vermas={t('see_more')}/>
  }

  return (
    <div className={showLoading ? "container" : "contenedor"}>
      {titleSlide}
      <div className={!showLoading ? (width >= sm && width < lg && isFestival? "tablet-container": "container") : ""}>{contentSlide}</div>
      {seeMoreSlide}
    </div>
  );
};

export default Carousel;
